import { useEffect, useState } from "react";
import { Application } from "../../System/Application/Application";

import "./PhotoGallery.css";
import photo_1 from "url:./assets/photography/1.jpg";
import photo_2 from "url:./assets/photography/2.jpg";
import photo_3 from "url:./assets/photography/3.jpg";
import photo_4 from "url:./assets/photography/4.jpg";
import photo_5 from "url:./assets/photography/5.jpg";
import photo_6 from "url:./assets/photography/6.jpg";
import photo_7 from "url:./assets/photography/7.jpg";
import photo_8 from "url:./assets/photography/8.jpg";
import photo_9 from "url:./assets/photography/9.jpg";
import photo_10 from "url:./assets/photography/10.jpg";
import photo_11 from "url:./assets/photography/11.jpg";
import photo_12 from "url:./assets/photography/12.jpg";
import photo_13 from "url:./assets/photography/13.jpg";
import photo_14 from "url:./assets/photography/14.jpg";
import photo_15 from "url:./assets/photography/15.jpg";
import photo_16 from "url:./assets/photography/16.jpg";
import photo_17 from "url:./assets/photography/17.jpg";
import photo_18 from "url:./assets/photography/18.jpg";
import photo_19 from "url:./assets/photography/19.jpg";
import photo_20 from "url:./assets/photography/20.jpg";
import photo_21 from "url:./assets/photography/21.jpg";
import photo_22 from "url:./assets/photography/22.jpg";
import photo_23 from "url:./assets/photography/23.jpg";
import photo_24 from "url:./assets/photography/24.jpg";
import photo_25 from "url:./assets/photography/25.jpg";
import photo_26 from "url:./assets/photography/26.jpg";
import photo_27 from "url:./assets/photography/27.jpg";
import photo_28 from "url:./assets/photography/28.jpg";
import photo_29 from "url:./assets/photography/29.jpg";
import photo_30 from "url:./assets/photography/30.jpg";
import photo_31 from "url:./assets/photography/31.jpg";
import photo_32 from "url:./assets/photography/32.jpg";
import photo_33 from "url:./assets/photography/33.jpg";
import photo_34 from "url:./assets/photography/34.jpg";
import photo_35 from "url:./assets/photography/35.jpg";
import photo_36 from "url:./assets/photography/36.jpg";
import photo_37 from "url:./assets/photography/37.jpg";
import photo_38 from "url:./assets/photography/38.jpg";
import photo_39 from "url:./assets/photography/39.jpg";
import photo_40 from "url:./assets/photography/40.jpg";
import photo_41 from "url:./assets/photography/41.jpg";
import photo_42 from "url:./assets/photography/42.jpg";
import photo_43 from "url:./assets/photography/43.jpg";

import project_1 from "url:./assets/projects/L2_Network_Result.jpg";
import project_2 from "url:./assets/projects/L3_Gomoku_3D.png";
import project_3 from "url:./assets/projects/L3_IIEST_3D_Discrete.png";
import project_4 from "url:./assets/projects/L3_IIEST_Filtre.png";
import project_5 from "url:./assets/projects/L3_IIEST_Yolo.png";
import project_6 from "url:./assets/projects/M1_IHM_Lando.png";
import project_7 from "url:./assets/projects/M1_IHM_Voxelcraft.png";
import project_8 from "url:./assets/projects/M1_Internship_GraphPipeline.png";
import project_9 from "url:./assets/projects/M1_ReasearchLab_Poster.jpg";
import project_10 from "url:./assets/projects/M1_Watermarking_Result.png";
import project_11 from "url:./assets/projects/M2_DataVis_Vortexes.jpg";

export function PhotoGallery(props) {
    const elements = [
        {
            id: "photos",
            type: "directory",
            name_fr: "Photos",
            name_en: "Photos",
            files: [
                { id: "photo_1", type: "file", url: photo_1 },
                { id: "photo_2", type: "file", url: photo_2 },
                { id: "photo_3", type: "file", url: photo_3 },
                { id: "photo_4", type: "file", url: photo_4 },
                { id: "photo_5", type: "file", url: photo_5 },
                { id: "photo_6", type: "file", url: photo_6 },
                { id: "photo_7", type: "file", url: photo_7 },
                { id: "photo_8", type: "file", url: photo_8 },
                { id: "photo_9", type: "file", url: photo_9 },
                { id: "photo_10", type: "file", url: photo_10 },
                { id: "photo_11", type: "file", url: photo_11 },
                { id: "photo_12", type: "file", url: photo_12 },
                { id: "photo_13", type: "file", url: photo_13 },
                { id: "photo_14", type: "file", url: photo_14 },
                { id: "photo_15", type: "file", url: photo_15 },
                { id: "photo_16", type: "file", url: photo_16 },
                { id: "photo_17", type: "file", url: photo_17 },
                { id: "photo_18", type: "file", url: photo_18 },
                { id: "photo_19", type: "file", url: photo_19 },
                { id: "photo_20", type: "file", url: photo_20 },
                { id: "photo_21", type: "file", url: photo_21 },
                { id: "photo_22", type: "file", url: photo_22 },
                { id: "photo_23", type: "file", url: photo_23 },
                { id: "photo_24", type: "file", url: photo_24 },
                { id: "photo_25", type: "file", url: photo_25 },
                { id: "photo_26", type: "file", url: photo_26 },
                { id: "photo_27", type: "file", url: photo_27 },
                { id: "photo_28", type: "file", url: photo_28 },
                { id: "photo_29", type: "file", url: photo_29 },
                { id: "photo_30", type: "file", url: photo_30 },
                { id: "photo_31", type: "file", url: photo_31 },
                { id: "photo_32", type: "file", url: photo_32 },
                { id: "photo_33", type: "file", url: photo_33 },
                { id: "photo_34", type: "file", url: photo_34 },
                { id: "photo_35", type: "file", url: photo_35 },
                { id: "photo_36", type: "file", url: photo_36 },
                { id: "photo_37", type: "file", url: photo_37 },
                { id: "photo_38", type: "file", url: photo_38 },
                { id: "photo_39", type: "file", url: photo_39 },
                { id: "photo_40", type: "file", url: photo_40 },
                { id: "photo_41", type: "file", url: photo_41 },
                { id: "photo_42", type: "file", url: photo_42 },
                { id: "photo_43", type: "file", url: photo_43 },
            ],
        },
        {
            id: "projects",
            type: "directory",
            name_fr: "Projets Variés",
            name_en: "Various Projects",
            files: [
                { id: "project_1", type: "file", url: project_1 },
                { id: "project_2", type: "file", url: project_2 },
                { id: "project_3", type: "file", url: project_3 },
                { id: "project_4", type: "file", url: project_4 },
                { id: "project_5", type: "file", url: project_5 },
                { id: "project_6", type: "file", url: project_6 },
                { id: "project_7", type: "file", url: project_7 },
                { id: "project_8", type: "file", url: project_8 },
                { id: "project_9", type: "file", url: project_9 },
                { id: "project_10", type: "file", url: project_10 },
                { id: "project_11", type: "file", url: project_11 },
            ],
        },
    ];

    const [openedDirectory, setOpenedDirectory] = useState(null);
    const [openedFile, setOpenedFile] = useState(null);

    const viewFolderContent = (el, index) => {
        if (el.type === "directory") {
            return (
                <div
                    key={index}
                    className="photo-gallery_directory"
                    onClick={() => {
                        setOpenedDirectory(el);
                        setOpenedFile(null);
                    }}
                >
                    <div className="photo-gallery_directory-preview">
                        {el.files.map((file, fileIndex) => {
                            if (fileIndex >= 4) {
                                return null;
                            }
                            return (
                                <img
                                    key={fileIndex}
                                    src={file.url}
                                    alt=""
                                    className="photo-gallery_directory-preview_image"
                                />
                            );
                        })}
                    </div>
                    <span className="photo-gallery_directory-name">
                        {props.language === "Fr" ? el.name_fr : el.name_en}
                    </span>
                </div>
            );
        } else if (el.type === "file") {
            return (
                <div
                    key={index}
                    className="photo-gallery_file"
                    onClick={() => {
                        setOpenedFile(el);
                    }}
                >
                    <img
                        src={el.url}
                        alt=""
                        className="photo-gallery_file-image"
                    />
                </div>
            );
        }
    };

    if (openedFile) {
        return (
            <Application {...props}>
                <div className="photo-gallery_file-viewer">
                    <button
                        className="photo-gallery_file-viewer-button"
                        onClick={() => setOpenedFile(null)}
                    >
                        {props.language === "Fr"
                            ? "Retour à la galerie"
                            : "Back to Gallery"}
                    </button>
                    <img
                        src={openedFile.url}
                        alt=""
                        className="photo-gallery_file-viewer-image"
                    />
                </div>
            </Application>
        );
    }

    return (
        <Application title={props.title} {...props}>
            <div className="photo-gallery">
                {openedDirectory && (
                    <button
                        className="photo-gallery_toolbar-button"
                        onClick={() => {
                            setOpenedDirectory(null);
                            setOpenedFile(null);
                        }}
                    >
                        {props.language === "Fr" ? "Retour" : "Back"}
                    </button>
                )}
                <div
                    className={`photo-gallery_content ${
                        openedDirectory
                            ? "photo-gallery_content-directory"
                            : "photo-gallery_content-home"
                    }`}
                >
                    <div
                        className={`photo-gallery_files ${
                            openedDirectory
                                ? "photo-gallery_files-directory"
                                : "photo-gallery_files-home"
                        }`}
                        style={
                            openedDirectory
                                ? {}
                                : {
                                      width: `min(calc((min(33vh, 33vw) + 28px + 16px) * ${elements.length}), 100%)`,
                                  }
                        }
                    >
                        {openedDirectory == null
                            ? elements.map(viewFolderContent)
                            : openedDirectory.files.map(viewFolderContent)}
                    </div>
                </div>
            </div>
        </Application>
    );
}
